import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { TechDocsAddonLocations } from '@backstage/plugin-techdocs-react';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';
import { RelatedArticlesAddon } from './RelatedArticlesAddon';

/*
 * Related articles close the article rather than sit beside it: the addon
 * renders at the end of the content column, under the prev/next divider, as the
 * three-up card row the reader design calls for.
 */
const relatedArticlesAddon = AddonBlueprint.make({
  name: 'related-articles',
  params: {
    name: 'RelatedArticles',
    location: TechDocsAddonLocations.Content,
    component: RelatedArticlesAddon,
  },
});

export const techdocsRelatedArticlesAddonModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [relatedArticlesAddon],
});
